<form novalidate #jmepReflectorForm="ngForm">
  <div class="jmep-settings">
    <div class="modal-header">
      <div class="reflector-header">
        <span class="header"><b>Endpoint </b> {{ deviceName }}</span>
        <i class="mdi mdi-close close-icon" mat-dialog-close></i>
      </div>
    </div>
    <div class="layout-row">
      <div class="loader-content" *ngIf="isLoadingConfig()">
        <div class="spinner">
          <mat-spinner [diameter]="60"></mat-spinner>
        </div>
        <div class="loader-text">
          <div class="text-message">Loading...</div>
        </div>
      </div>

      <div class="configsContainer" *ngIf="jmepLicenseEnabled && isLicenseLoaded">
        <div *ngIf="isTestRunning && raiseConfirm">
          <div
            layout="row"
            layout-align="center center"
            class="twamp-reflect-action message"
            *ngIf="actionMsg || errorMsg"
          >
            <div class="loader-content" *ngIf="actionMsg">
              <div class="spinner">
                <mat-spinner [diameter]="60"></mat-spinner>
              </div>
              <div class="loader-text">
                <div class="text-message">{{ actionMsg }}</div>
              </div>
            </div>
            <div
              *ngIf="errorMsg"
              class="row"
              class="twamp-error-msg"
              [color]="{
                success: errorIcon !== 'warning',
                warn: errorIcon === 'warning'
              }"
            >
              <mat-icon
                class="material-icons"
                [ngClass]="{
                  success: errorIcon !== 'warning',
                  warn: errorIcon === 'warning'
                }"
                >{{ errorIcon }}</mat-icon
              >
              <span class="error-msg">{{ errorMsg }}</span>
              <button
                mat-raised-button
                [color]="errorIcon === 'warning' ? 'warn' : 'primary'"
                (click)="confirmationDialogokClicked()"
                *ngIf="errorMsg"
              >
                ok
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="!raiseConfirm">
          <h4 class="jmep-reflector-settings">
            <mat-icon class="material-icons md-18">settings</mat-icon>
            <span>JMEP Reflector Settings</span>
          </h4>
          <div class="form-content">
            <div class="row">
              <div class="control-group ip-address-align">
                <label class="labelMode">IP Address: {{ ipAddress }}</label>
              </div>
              <div class="control-group">
                <label class="labelMode">UDP Port: </label>
                <input
                  matInput
                  [(ngModel)]="formObj.udpport"
                  name="udpport"
                  [disabled]="isTestRunning"
                  #udpInput="ngModel"
                  class="control input-decor input-ipv4"
                  required
                  (ngModelChange)="handleReflectorLightPortRange()"
                />
                <div class="err-msgContainer">
                  <mat-error *ngIf="udpInput?.errors?.required"> Required field</mat-error>
                  <mat-error *ngIf="udpInput?.errors?.regex">1-65535 except 5060</mat-error>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="vlan">
              <div class="control-group ip-address-align">
                <label class="labelMode">VLAN: {{ vlan }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <button
              mat-raised-button
              color="primary"
              (click)="startEndpoint()"
              [disabled]="!form?.valid"
              *ngIf="!isTestRunning && !errorMsg && !actionMsg"
            >
              <mat-icon class="material-icons">play_arrow</mat-icon>Start Reflector
            </button>
            <button
              mat-raised-button
              color="warn"
              (click)="showStopDialog()"
              *ngIf="isTestRunning && !errorMsg && !actionMsg"
            >
              <mat-icon class="material-icons">stop</mat-icon>Stop Reflector
            </button>
            <div class="row twamp-reflect-action message" *ngIf="actionMsg || errorMsg">
              <mat-spinner
                [diameter]="30"
                class="twamp-reflect-progress mat-warn mat-hue-1"
                *ngIf="actionMsg"
              >
              </mat-spinner>

              <div *ngIf="actionMsg">{{ actionMsg }}</div>
              <div
                *ngIf="errorMsg"
                class="row center twamp-error-msg"
                [color]="{
                  success: errorIcon !== 'warning',
                  warn: errorIcon === 'warning'
                }"
              >
                <mat-icon
                  class="material-icons"
                  [ngClass]="{
                    success: errorIcon !== 'warning',
                    warn: errorIcon === 'warning'
                  }"
                  >{{ errorIcon }}</mat-icon
                >
                <span class="error-msg">{{ errorMsg }}</span>
                <button
                  mat-raised-button
                  [color]="errorIcon === 'warning' ? 'warn' : 'primary'"
                  (click)="okClicked()"
                  *ngIf="errorMsg"
                >
                  ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div layout="layout-row" *ngIf="!jmepLicenseEnabled && isLicenseLoaded">
      <div class="errMSGContainer">
        <p>JMEP TWAMP test license is missing. Please contact VIAVI customer support.</p>
        <mat-dialog-actions>
          <button
            mat-raised-button
            [color]="errorIcon === 'warning' ? 'warn' : 'primary'"
            (click)="cancelstop()"
          >
            ok
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</form>
